import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const BUNDLE_HERO_ASPECT_RATIO = 375 / 180;
export const BUNDLE_FOOTER_MIN_BOTTOM_SPACING = theme.spacing['6'];
export const BUNDLE_FOOTER_BUTTON_HEIGHT = 64;
export const BUNDLE_TRANSITION_DURATION = theme.transitions.base;
